import React, { lazy, Suspense } from 'react'
import { Switch, Route } from 'react-router-dom'
import { Typography } from 'antd'

//style
import './index.css'
import typo from "../../constants/dictionaries";

const { Title } = Typography;

// Components
const BieuMauSo1 = lazy(() => import('./BieuMauSo1'));
const BieuMauSo9 = lazy(() => import('./BieuMauSo9'));
const BieuMauSo10 = lazy(() => import('./BieuMauSo10'));
const BieuMauSo11 = lazy(() => import('./BieuMauSo11'));
const BieuMauSo16 = lazy(() => import('./BieuMauSo16'));
const PhuLuc2 = lazy(() => import('./PhuLuc2'));
const PhuLuc3 = lazy(() => import('./PhuLuc3'));
const PhuLuc5 = lazy(() => import('./PhuLuc5'));
const PhuLuc6 = lazy(() => import('./PhuLuc6'));

export default ({ match }) => {
  const groupName = 'Báo cáo thống kê'
  const BieuMauSo1Link = 'bieu-mau-so-1'
  const BieuMauSo9Link = 'bieu-mau-so-9'
  const BieuMauSo10Link = 'bieu-mau-so-10'
  const BieuMauSo11Link = 'bieu-mau-so-11'
  const BieuMauSo16Link = 'bieu-mau-so-16'
  const PhuLuc2Link = 'phu-luc-2'
  const PhuLuc3Link = 'phu-luc-3'
  const PhuLuc5Link = 'phu-luc-5'
  const PhuLuc6Link = 'phu-luc-6'

  return (
    <Suspense fallback={() => <Title level={4}>Loading</Title>}>
      <Switch>
        <Route exact path={`${match.path}/${BieuMauSo1Link}`} render={(props) => <BieuMauSo1 {...props} path={`${match.path}/${BieuMauSo1Link}`} groupName={groupName} name={typo.cscore_BieuMauSo1} />} />
        <Route exact path={`${match.path}/${BieuMauSo9Link}`} render={(props) => <BieuMauSo9 {...props} path={`${match.path}/${BieuMauSo9Link}`} groupName={groupName} name={typo.cscore_BieuMauSo9} />} />
        <Route exact path={`${match.path}/${BieuMauSo10Link}`} render={(props) => <BieuMauSo10 {...props} path={`${match.path}/${BieuMauSo10Link}`} groupName={groupName} name={typo.cscore_BieuMauSo10} />} />
        <Route exact path={`${match.path}/${BieuMauSo11Link}`} render={(props) => <BieuMauSo11 {...props} path={`${match.path}/${BieuMauSo11Link}`} groupName={groupName} name={typo.cscore_BieuMauSo11} />} />
        <Route exact path={`${match.path}/${BieuMauSo16Link}`} render={(props) => <BieuMauSo16 {...props} path={`${match.path}/${BieuMauSo16Link}`} groupName={groupName} name={typo.cscore_BieuMauSo16} />} />
        <Route exact path={`${match.path}/${PhuLuc2Link}`} render={(props) => <PhuLuc2 {...props} path={`${match.path}/${PhuLuc2Link}`} groupName={groupName} name={typo.cscore_PhuLuc2} />} />
        <Route exact path={`${match.path}/${PhuLuc3Link}`} render={(props) => <PhuLuc3 {...props} path={`${match.path}/${PhuLuc3Link}`} groupName={groupName} name={typo.cscore_PhuLuc3} />} />
        <Route exact path={`${match.path}/${PhuLuc5Link}`} render={(props) => <PhuLuc5 {...props} path={`${match.path}/${PhuLuc5Link}`} groupName={groupName} name={typo.cscore_PhuLuc5} />} />
        <Route exact path={`${match.path}/${PhuLuc6Link}`} render={(props) => <PhuLuc6 {...props} path={`${match.path}/${PhuLuc6Link}`} groupName={groupName} name={typo.cscore_PhuLuc6} />} />

      </Switch>
    </Suspense>
  )
}